import { getOrCreateClientSessionId } from './clientSessionId';

type DescopeActionPayload = Record<string, unknown>;

export const withClientSessionId = <TPayload extends DescopeActionPayload>(
  payload: TPayload
): TPayload & {
  'form.sessionId'?: string;
} => {
  const sessionId = getOrCreateClientSessionId();

  return {
    ...payload,
    ...(sessionId ? { 'form.sessionId': sessionId } : {}),
  };
};
